import { render, staticRenderFns } from "./IconExecute.vue?vue&type=template&id=4c4872d1&scoped=true"
import script from "./IconExecute.vue?vue&type=script&lang=js"
export * from "./IconExecute.vue?vue&type=script&lang=js"
import style0 from "./IconExecute.vue?vue&type=style&index=0&id=4c4872d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4872d1",
  null
  
)

export default component.exports